import { Biotech, CalendarToday, Loop, Person } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { styled, Stack, Box } from "@mui/system";
import theme from "../../../theme";

export const MetadataRow = styled(Stack)`
  margin-bottom: 4px;
`;

export const MetadataItem = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${theme.palette.secondary.main};
  gap: 3px;
`;

export const CalendarTodayIcon = styled(CalendarToday)`
  font-size: inherit;
`;

export const SubmittedByIcon = styled(Person)`
  font-size: 14px;
`;

export const CollectionDateTypography = styled(Typography)`
  color: ${theme.palette.secondary.main};
`;

export const SubmittedByLabelTypography = styled(Typography)`
  color: ${theme.palette.secondary.main};
`;

export const SubmittedByTypography = styled(Typography)`
  color: ${theme.palette.secondary.main};
  font-weight: 500;
`;

export const RecurringTypography = styled(Typography)`
  color: ${theme.palette.secondary.main};
`;

export const LoopIcon = styled(Loop)`
  font-size: 14px;
`;

export const BiotechIcon = styled(Biotech)`
  font-size: 14px;
`;

export const LabNameTypography = styled(Typography)``;
